import type {
  AuthenticationContextType,
  BankIDError,
  IBankIDIdentificationContext,
} from "../common-types";

export enum SEBankIDFlowState {
  NOT_INITIATED = "notInitiated",
  PENDING = "pending",
  COMPLETE = "complete",
  FAILED = "failed",
}

export enum SEBankIDHintCode {
  OUTSTANDING_TRANSACTION = "outstandingTransaction",
  NO_CLIENT = "noClient",
  STARTED = "started",
  USER_SIGN = "userSign",
  USER_CANCEL = "userCancel",
  EXPIRED_TRANSACTION = "expiredTransaction",
  CERTIFICATE_ERR = "certificateErr",
  START_FAILED = "startFailed",
  ERROR = "error",
}

export enum SEBankIDAuthType {
  QR_CODE = "QR_CODE",
  AUTO_START = "AUTO_START",
  SSN = "SSN", // Only for testing
}

export interface ISEBankIDAuthenticateResponse {
  orderRef: string;
  qrCode: string | null;
  autoStartToken: string | null;
}

export interface ISEBankIDCollectResponse {
  orderRef: string;
  status: SEBankIDFlowState;
  hintCode: SEBankIDHintCode | null;
  qrCode: string;
  tokens: {
    accessToken: string;
    refreshToken: string;
  };
}

export interface ISEBankIDCollectParams {
  orderRef: string;
  authenticationContext?: AuthenticationContextType;
  identificationContext?: IBankIDIdentificationContext | null;
  extraData: {
    preferredLanguage?: string | null;
    gaClientId?: string | null;
  } | null;
}

export type SEBankIDState =
  | { status: "idle" }
  | { status: "authenticating"; authType?: SEBankIDAuthType }
  | {
      status: "pending";
      authType?: SEBankIDAuthType;
      hintCode: SEBankIDHintCode;
    }
  | { status: "success" }
  | { status: "error"; error: BankIDError; hintCode: SEBankIDHintCode }
  | { status: "cancelled"; hintCode: SEBankIDHintCode };
